/* Prefetch likely storefront destinations after clear navigation intent.
   This keeps Shopify's normal document navigation intact while allowing the
   browser to warm its HTTP cache before a menu or product-card click. */
(function () {
  'use strict';

  var prefetched = new Set();
  var hoverTimers = new WeakMap();
  var maxPrefetches = 16;
  var allowedPaths = /^\/(?:collections|products|pages|blogs|search)(?:\/|$)/;

  function canPrefetch() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    return (
      !connection ||
      (!connection.saveData && connection.effectiveType !== 'slow-2g' && connection.effectiveType !== '2g')
    );
  }

  function destination(link) {
    if (
      !link ||
      link.target ||
      link.hasAttribute('download') ||
      link.getAttribute('href') === '#' ||
      link.getAttribute('href') === ''
    ) {
      return null;
    }

    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (e) {
      return null;
    }

    if (url.origin !== window.location.origin || url.hash || !allowedPaths.test(url.pathname)) return null;
    return url.href;
  }

  function prefetch(link) {
    var href = destination(link);
    if (!href || prefetched.has(href) || prefetched.size >= maxPrefetches || !canPrefetch()) return;

    prefetched.add(href);
    var hint = document.createElement('link');
    hint.rel = 'prefetch';
    hint.as = 'document';
    hint.href = href;
    document.head.appendChild(hint);
  }

  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType === 'touch') return;
      var link = event.target.closest && event.target.closest('a[href]');
      if (!link || hoverTimers.has(link)) return;
      hoverTimers.set(
        link,
        window.setTimeout(function () {
          hoverTimers.delete(link);
          prefetch(link);
        }, 75),
      );
    },
    { passive: true },
  );

  document.addEventListener(
    'pointerout',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      var timer = link && hoverTimers.get(link);
      if (timer) {
        window.clearTimeout(timer);
        hoverTimers.delete(link);
      }
    },
    { passive: true },
  );

  document.addEventListener('focusin', function (event) {
    var link = event.target.closest && event.target.closest('a[href]');
    prefetch(link);
  });

  document.addEventListener(
    'touchstart',
    function (event) {
      var link = event.target.closest && event.target.closest('a[href]');
      prefetch(link);
    },
    { passive: true },
  );
})();
